import { ProgramCard } from "../../pages/shared/Home/containers";
import styles from "./styles.module.css";

export const ApplicationTabs = ({ items, handleCurrentLink }) => {
	return (
		<div className={styles.applicationTabs}>
			<div className={styles.application_section_header}>
				<h2 className="pb-1">Our Programmes</h2>
				<p>
					Explore a World of Learning Possibilities: Discover Our
					Diverse Academic Pathways
				</p>
			</div>
			<div className={styles.application_tab_tabs}>
				{items?.map((item, idx) => (
					<ProgramCard
						key={idx}
						{...item}
						handleCurrentLink={handleCurrentLink}
					/>
				))}
			</div>
		</div>
	);
};
